/**
 * Видео-инструкции на entry-экранах (PRD §16.4 / B-008).
 *
 * **PLACEHOLDER URLs** — реальные ссылки даст продакт в Phase 8/9 после съёмки.
 * Сейчас iframe указывает на несуществующие YouTube IDs — embed загрузит
 * «Video unavailable» страницу. Это нормально для MVP — UX-структура верна,
 * содержание заменяется без изменения кода.
 */

export const DECOR_VIDEO_URL = 'https://www.youtube.com/embed/PLACEHOLDER_DECOR_INTRO';

export const HANDLES_VIDEO_URL = 'https://www.youtube.com/embed/PLACEHOLDER_HANDLES_INTRO';

export const CONFIGURATOR_VIDEO_URL =
  'https://www.youtube.com/embed/PLACEHOLDER_CONFIGURATOR_INTRO';

export const FURNITURE_VIDEO_URL = 'https://www.youtube.com/embed/PLACEHOLDER_FURNITURE_INTRO';
